import { InjectionToken, signal, WritableSignal } from "@angular/core";
import { Preview } from "@models/interfaces/core/Preview.interface";

export const APP_PREVIEW: InjectionToken<WritableSignal<Preview>> = new InjectionToken<WritableSignal<Preview>>('App Preview');

const PreviewValues: Preview = {
  id: 0,
  slug: '',
  venue_code: '',
  map_id: '',
  url: '',
  redirect_url: null,
  venue_key: '',
  path_master: '',
  path_app: '',
  active: false,
  test: false,
  created_by: null,
  updated_by: null,
  created_at: null,
  updated_at: null,
  global_template: null,
  global_template_id: null,
  accounts: []
};

const PreviewData: WritableSignal<Preview> = signal(PreviewValues);

export const AppPreview: {provide: InjectionToken<Preview>, useValue: WritableSignal<Preview>} = {
    provide:   APP_PREVIEW,
    useValue:  PreviewData
}